export namespace TRACKING {
  export enum TYPE {
    VIEW = "view",
    ACKNOWLEDGEMENT = "acknowledgement",
    ACKNOWLEDGEMENT_SMS = "acknowledgement_sms",
  }

  export enum TARGET_TYPE {
    ESCALATION_REPORT = "escalation",
    FLAGGED_RESIDENT = "flagged",
    BED_EXIT_NOTIFICATION = "bed_exit_notification",
    BED_EXIT_EVENT = "bed_exit_event",
    PATIENT_CHART = "patient_chart",
    HOTLIST = "hotlist",
    ADMISSION = "admission",
  }

  export enum APPLICATION {
    CIP = "CIP",
    WEB_PORTAL = "WebPortal",
  }
}
